import Vue from 'vue';
const serviceCompliance = {
  state: {
    serviceCompliance: [],
    sixMo: [],
    twelveMo: [],
    eighteenMo: [],
    twentyfourMo: [],
  },

  getters: {
    serviceCompliance(state) {
      return state.serviceCompliance;
    },
    sixMo(state) {
      return state.sixMo;
    },
    twelveMo(state) {
      return state.twelveMo;
    },
    eighteenMo(state) {
      return state.eighteenMo;
    },
    twentyfourMo(state) {
      return state.twentyfourMo;
    },
  },

  mutations: {
    getServiceCompliance(state, payload) {
      state.serviceCompliance = payload;
    },
    getSixMo(state, payload) {
      state.sixMo = payload;
    },
    getTwelveMo(state, payload) {
      state.twelveMo = payload;
    },
    getEighteenMo(state, payload) {
      state.eighteenMo = payload;
    },
    getTwentyFourMo(state, payload) {
      state.twentyfourMo = payload;
    },
  },

  actions: {
    getServiceCompliance(context, payload) {
      const url = 'ServiceCompliance';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getServiceCompliance', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    get6Mo(context, payload) {
      const url = 'ServiceCompliance/6mo';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getSixMo', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    get12Mo(context, payload) {
      const url = 'ServiceCompliance/12mo';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getTwelveMo', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    get18Mo(context, payload) {
      const url = 'ServiceCompliance/18mo';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getEighteenMo', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    get24Mo(context, payload) {
      const url = 'ServiceCompliance/24mo';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getTwentyFourMo', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    updateServiceCompliance(context, payload){
      const url = `ServiceCompliance/${ payload.ID }`;
      Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('getServiceCompliance')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    createServiceCompliance(context, payload){
      const url = `ServiceCompliance`;
      Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('getServiceCompliance')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    deleteServiceCompliance(context, payload){
      const url = `ServiceCompliance/${ payload.ID }`;
      Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('getServiceCompliance')
          },
          (error) => {
            console.log(error);
          },
        );
    }
  },
}

export default serviceCompliance